import * as api from 'shared/childupp-api';

/**
 * @typedef {object} VersionSpec
 * @property {string} version - semver-compliant version
 * @property {string} root - Base URL where {@link #files} can be retrieved from
 * @property {string[]} files - List of all files necessary for running this version
 */

/**
 * @type {Promise.<VersionSpec> | null}
 */
let versionCache = null;

/**
 * Retrieves the latest version specification from the remote server.
 * @return {Promise.<VersionSpec>}
 */
export function getLatestVersion() {
    if (!versionCache) {
        versionCache = api.fetch({
            method: 'GET',
            url: `/v2/update/check?current_version=${__VERSION__}`,
        });
    }
    return versionCache;
}



// WEBPACK FOOTER //
// ./src/shared/childupp-auto-update/cordova-auto-update/versions-api.js